// extracted by mini-css-extract-plugin
export default {"container":"LoginUser_container__i082Y","login-dialog":"LoginUser_login-dialog__zc5hH"};